<template>
    <div id="dropdownMenu" class="tw-flex tw-items-center tw-relative tw-cursor-pointer">
        <div
            class="dropdown-trigger tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap"
            @click="isDropdownOpen = ! isDropdownOpen"
        >
            Weitere:
            <i v-if="! isDropdownOpen" class="fa fa-chevron-down tw-text-brand-primary"></i>
            <i v-if="isDropdownOpen" class="fa fa-chevron-up tw-text-brand-primary"></i>
        </div>

        <ul
            class="tw-absolute tw-bg-white tw-border tw-border-slate-grey tw-flex tw-flex-col tw-rounded"
            style="top: 100%"
            v-if="isDropdownOpen"
            v-closable="{
                exclude: ['.dropdown-trigger'],
                handler: 'onClose'
            }"
        >
            <li v-for="(item, index) in tabNavArray" :key="item.id"
                :class="{ 'tw-bg-brand-primary tw-text-brand-primary-foreground': item.is_active, 'additional-tabs': item.additional }"
                class="cu-dropdown-item hover:tw-text-brand-primary-foreground hover:tw-bg-brand-primary focus:tw-bg-brand-primary active:tw-bg-brand-primary focus:tw-tw-text-brand-primary-foreground active:tw-tw-text-brand-primary-foreground tw-no-underline hover:tw-no-underline active:tw-no-underline focus:tw-no-underline">
                <a class="tw-block tw-px-4 tw-py-2 hover:tw-text-brand-primary-foreground focus:tw-text-brand-primary-foreground active:tw-tw-text-brand-primary-foreground hover:tw-no-underline tw-no-underline tw-whitespace-nowrap"
                   :href="'/applications/inbox/' + item.id"
                >
                    {{ item.department_name }}
                    <span
                        class="cu-dropdown-item-count tw-ml-1 tw-leading-snug tw-inline-flex tw-items-center tw-text-brand-primary-foreground tw-text-xs tw-rounded-full tw-px-2"
                        :class="item.is_active ? 'tw-bg-white tw-text-brand-primary': 'tw-bg-brand-primary'"
                    >
                        {{ item.count_unread }}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
    .cu-dropdown-item {
        &:hover {
            .cu-dropdown-item-count {
                background-color: var(--color-brand-primary-foreground);
                color: var(--color-brand-primary);
            }
        }
    }
</style>

<script>
export default {
    props: ['tabNav'],

    data() {
        return {
            isDropdownOpen: false,
            tabNavArray: Object.values(this.tabNav)
        }
    },

    methods: {
        onClose() {
            this.isDropdownOpen = false
        },
    },

    mounted() {
    }
}
</script>
